//
// Admin bar user search UI component.
//

import { component as defineComponent, utils } from 'flightjs';

function UserSearch() {
    this.lastQuery = null;

    this.attributes({
        'queryInput': 'input[name=q]',
        'searchResults': '[data-user-search-results]',
        'toggleButton': '[data-dropdown-toggle]',
        'searchForm': '[data-user-search-form]',
        'menuTrigger': '[data-user-search-menu-trigger]'
    });

    this.after('initialize', function() {
        this.on('keyup', { searchForm: utils.debounce(this.handleSearch) });
        this.on('submit', { searchForm: this.handleSearch });
        this.on(document, 'brandContainer.data.userSearch', this.showResults);
        this.on('click', {
            toggleButton: this.toggle,
            menuTrigger: this.focusSearch
        });
    });

    this.focusSearch = function (e) {
        setTimeout(function() {
            this.select('queryInput').focus();
        }.bind(this), 100);
    };

    // Triggers the search event, passing the search query
    this.handleSearch = function (e) {
        var query = this.select('queryInput').val();

        e.preventDefault();

        if (e.keyCode === 27) {
            this.select('menuTrigger').click();
        }

        if (!this.lastQuery || this.lastQuery !== query) {
            this.trigger(document, 'brandContainer.ui.requestUserSearch', [query]);
            this.lastQuery = query;
        }
    };

    this.showResults = function (e, data) {
        this.select('searchResults').html(data);
        this.trigger('uiNeedsTimeUpdate');
    };

    this.show = function () {
        this.$node.attr('data-active', '');
        this.select('queryInput').focus();
    };

    this.hide = function () {
        this.$node.removeAttr('data-active');
    };

    this.toggle = function (e) {
        e.preventDefault();
        if (this.$node.is('[data-active]')) {
            this.hide();
        } else {
            this.show();
        }
    };
};

export default defineComponent(UserSearch);



// WEBPACK FOOTER //
// ./~/@99designs/brand-container/lib/ui/user-search.js